import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Login from './components/Login'
import DashboardAtual from "./components/DashboardAtual";
import DashboardMensal from "./components/DashboardMensal";
import withAuth from './components/withAuth';
import PrimeiroLogin from './components/PrimeiroLogin'
import CadastrarSenha from './components/CadastrarSenha'
import RecuperarSenha from './components/RecuperarSenha'
import { URL } from './constants/index'

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path={URL.URLLogin} component={Login} />
      <Route exact path={URL.URLPrimeiroLogin} component={PrimeiroLogin} />
      <Route exact path={URL.URLCadastrarSenha} component={CadastrarSenha} />
      <Route exact path={URL.URLRecuperarSenha} component={RecuperarSenha} />
      <Route exact path={URL.URLDashboardAtual} component={withAuth(DashboardAtual)} />
      <Route exact path={URL.URLDashboardMensal} component={withAuth(DashboardMensal)} />            
      <Route path="/" component={Login} />      
    </Switch>
  </BrowserRouter>
);

export default Routes;